import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || '/api',
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request interceptor - เพิ่ม token ใน header
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// เส้นทางที่ mutation (POST/PUT/PATCH/DELETE) มักทำให้ "งานรอดำเนินการ" เปลี่ยน
// -> ปล่อย event ให้ PendingWorkContext รีเฟรช badge โดยไม่ต้องไปแก้ทุกหน้าที่กดอนุมัติ/ปฏิเสธ
const PENDING_TOUCH_RE = /^\/?(admin|request|contact|users|staff)(\/|$|\?)/;

// Response interceptor - จัดการ error
api.interceptors.response.use(
    (response) => {
        try {
            const method = (response.config?.method || 'get').toLowerCase();
            const url = (response.config?.url || '').replace(/^\/api/, '');
            if (method !== 'get' && PENDING_TOUCH_RE.test(url)) {
                window.dispatchEvent(new Event('imoney:pending-refresh'));
            }
        } catch (e) { /* ignore */ }
        return response;
    },
    (error) => {
        // 401 จาก endpoint ของ Google (ผูก/เข้าสู่ระบบ) ไม่ใช่ session หมดอายุ — อย่าเด้งผู้ใช้ออก
        const reqUrl = error.config?.url || '';
        const status = error.response?.status;
        const isGoogleAuthCall = reqUrl.includes('/auth/link-google') || reqUrl.includes('/auth/google-login')
            || reqUrl.includes('/auth/providerid/exchange');
        if (status === 401 && !isGoogleAuthCall) {
            localStorage.removeItem('token');
            localStorage.removeItem('banInfo');
            if (window.location.pathname !== '/login') {
                // จำหน้าที่กำลังจะเข้า (เช่นลิงก์จาก LINE -> /admin/account-requests) ไว้ให้ Login พากลับมาหลังเข้าสู่ระบบ
                const here = window.location.pathname + window.location.search + window.location.hash;
                const next = (here && here !== '/') ? `?next=${encodeURIComponent(here)}` : '';
                window.location.href = `/login${next}`;
            }
        }

        // พาไปยืนยันอีเมล (เก็บข้อความไว้โชว์ที่หน้าโปรไฟล์)
        const gotoEmailGate = (msg) => {
            try {
                sessionStorage.setItem('emailGateMsg', msg || 'กรุณายืนยันอีเมลก่อน จึงจะพิมพ์หรือส่งออกเอกสารได้');
            } catch (e) { /* ignore */ }
            if (window.location.pathname !== '/profile') {
                window.location.href = '/profile#email';
            }
        };

        // 403 export gate — โหลด PDF (responseType:'blob'): body เป็น Blob ต้องอ่านเป็น text ก่อน
        if (status === 403 && error.response?.data instanceof Blob) {
            return error.response.data.text().then((txt) => {
                let code = '', msg = '';
                try { const j = JSON.parse(txt); code = j.error; msg = j.message; } catch (e) { /* not json */ }
                if (code === 'email_not_verified' || code === 'no_verified_email') gotoEmailGate(msg);
                return Promise.reject(error);
            }, () => Promise.reject(error));
        }

        // 403 export gate — JSON เฉพาะ endpoint ออกเอกสาร (/report/*) เช่น ส่งสลิปเข้าเมล
        // (contact / follow-up มี UI เตือนยืนยันอีเมลในหน้าเองอยู่แล้ว จึงไม่เด้งทั้งหน้า)
        const gateCode = error.response?.data?.error;
        if (status === 403 && (gateCode === 'email_not_verified' || gateCode === 'no_verified_email') && reqUrl.includes('/report/')) {
            gotoEmailGate(error.response?.data?.message);
        }

        // จัดการกับ banned error
        if (error.response?.status === 403 && error.response?.data?.error === 'banned') {
            localStorage.setItem('banInfo', JSON.stringify({
                message: error.response.data.message,
                banned_until: error.response.data.banned_until
            }));
            if (window.location.pathname !== '/banned') {
                window.location.href = '/banned';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
